import React, { useMemo } from 'react';
import axios from 'axios';
import config from '../../../../config';
import TransferList from '../shared/TransferList';

/**
 * Other-charges assignment for the current concessionaire. Each assigned
 * charge carries a per-concessionaire display name, so this tab enables
 * `requireDisplayName` — Add stays disabled until every selected charge
 * has a name (the old form silently posted `undefined`).
 */
const OtherChargesAdd = () => {
    const adapter = useMemo(() => {
        const concessionaire_id = localStorage.getItem('concessionaireId');
        const login_id = localStorage.getItem('loginId');
        const headers = { Authorization: `${localStorage.getItem('sessiontoken')}` };

        return {
            loadCatalog: async () => {
                try {
                    const res = await axios.get(`${config.hostname}/othercharges/getothercharges`, { headers });
                    return (res.data || []).map((c) => ({ id: c._id, label: c.charge_name }));
                } catch (err) {
                    if (err?.response?.status === 404) return [];
                    throw err;
                }
            },
            loadAssigned: async () => {
                try {
                    const res = await axios.post(
                        `${config.hostname}/concessionairecharges/getcharges`,
                        { concessionaire_id },
                        { headers },
                    );
                    // Backend 404s (not empty array) when none are assigned, and a
                    // row may carry a null other_charge_id — guard both.
                    return (res.data || [])
                        .filter((c) => c.other_charge_id)
                        .map((c) => ({ id: c.other_charge_id._id, label: c.display_name }));
                } catch (err) {
                    if (err?.response?.status === 404) return [];
                    throw err;
                }
            },
            assign: (items) =>
                axios.post(
                    `${config.hostname}/concessionairecharges/createcharges`,
                    {
                        concessionaire_id,
                        other_charge_id: items.map((i) => i.id),
                        display_name: items.map((i) => i.displayName),
                        login_id,
                    },
                    { headers },
                ),
            unassign: (ids) =>
                axios({
                    method: 'delete',
                    url: `${config.hostname}/concessionairecharges/removecharges`,
                    data: { concessionaire_id, other_charge_id: ids, login_id },
                    headers,
                }),
        };
    }, []);

    return (
        <TransferList
            adapter={adapter}
            availableTitle="Available charges"
            assignedTitle="Assigned charges"
            searchPlaceholder="Search charges…"
            requireDisplayName
        />
    );
};

export default OtherChargesAdd;
